<template>
    <a href="/club/release_notes" class="btn btn-info btn-sm navbar-btn new-highlight" id="whats-new">
        <span class="glyphicon glyphicon-bell" aria-hidden="true"></span>
    </a>
</template>
<style scoped>
    .el-notification.right {
        background-color: #dff0d8;
        border-color: #80ff00;
        color: #3c763d;

    }
</style>
<script>
    export default {
        props: {
            is_up_to_date: {
                type: Boolean,
                default: false
            }
        },
        data: function () {
            return {
                isUpToDate: this.is_up_to_date,
            }
        },
        mounted() {
            console.log('WhatsNew component mounted.');
            if (this.isUpToDate == false) {
                this.open();
            }
        },
        methods: {
            open() {
                this.$notify.info({
                    title: 'Whats New',
                    message: 'Click here to find out about new Swim Manager features',
                    type: 'success',
                    onClick: this.whatsNew,
                    duration: 0
                });
            },
            whatsNew() {
                window.location.href = "/club/release_notes"
            }
        }
    }
</script>